<template>
  <data-sync-panel title="海康数据同步" source="海康" :use-hik-api="true" />
</template>

<script>
import DataSyncPanel from '../components/DataSyncPanel'
export default {
  name: 'CheliangHikSync',
  components: { DataSyncPanel }
}
</script>
